
import { EventResponse } from '@/model/Event';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import ToggleableText from '@/components/form/ToggleableText.vue';
import EventIcon from './EventIcon.vue';

@Component({
    components: {
        ToggleableText,
        EventIcon,
    },
})
export default class EventHeader extends Vue {
    @Prop() readonly event!: EventResponse | null;
    onClick(): void {
        this.$router.push(`/event/${this.event?.id}/editors`);
    }

    @Emit('show-new-item-modal')
    showNewItemModal(): void {
        // emit
    }

    @Emit('show-duplicate-modal')
    showDuplicateModal(): void {
        // emit
    }

    @Emit('show-import-modal')
    showImportModal(): void {
        // emit
    }
}
